import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";

import { ApiService } from "../../../../shared/services/api/api.service";
import { API_ENDPOINTS } from "../../../../shared/services/api/api-endpoints";
import { LoaderComponent } from "../../../../shared/components/loader/loader.component";

@Component({
  selector: "business-account-password",
  standalone: true,
  imports: [ReactiveFormsModule, LoaderComponent],
  templateUrl: "./password.component.html",
  styleUrl: "./password.component.scss",
})
export class BusinessAccountPasswordComponent {
  accountPasswordForm: FormGroup;
  isLoading = false;

  showCurrentPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
  ) {
    this.accountPasswordForm = this.fb.group({
      current_password: ["", Validators.required],
      new_password: ["", [Validators.required, Validators.minLength(8)]],
      confirm_password: ["", Validators.required],
    });
  }

  isInvalid(path: string): boolean {
    const control = this.accountPasswordForm.get(path);
    return !!(control?.invalid && (control.touched || control.dirty));
  }

  isPasswordMatch(): boolean {
    const newPassword = this.accountPasswordForm.get("new_password")?.value;
    const confirmPassword =
      this.accountPasswordForm.get("confirm_password")?.value;

    const confirmTouched =
      this.accountPasswordForm.get("confirm_password")?.touched ||
      this.accountPasswordForm.get("confirm_password")?.dirty;

    if (!confirmTouched || !newPassword || !confirmPassword) return true;

    return newPassword === confirmPassword;
  }

  handleSave(): void {
    if (this.accountPasswordForm.invalid || !this.isPasswordMatch()) {
      this.accountPasswordForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    this.apiService
      .request(
        API_ENDPOINTS.owner.accountSettings.password,
        "POST",
        this.accountPasswordForm.value,
      )
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          this.accountPasswordForm.reset();

          Swal.fire({
            icon: "success",
            title: "Password updated successfully",
            text: response?.message || "Your password has been changed.",
            toast: true,
            position: "top-end",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              container: "!z-[999999]",
            },
          });
        },
        error: (error: any) => {
          this.isLoading = false;

          Swal.fire({
            icon: "error",
            title: "Error while updating password",
            text:
              error?.error?.message ||
              "An error occurred while updating the password. Please try again.",
            toast: true,
            position: "top-end",
            timer: 4000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: {
              container: "!z-[999999]",
            },
          });
        },
      });
  }

  resetForm(): void {
    this.accountPasswordForm.reset();
  }
}
